module.exports = __webpack_public_path__ + "img/J13.5752edc0.webp";